import { FC, useState } from 'react'
import styled from 'styled-components'
import { BD, Button, Folha, FolhaOverlay, FolhaPega, FolhaTopo } from '../styles'
import { ChaveTermo, GLOSSARIO } from './glossario'

const Gatilho = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  color: ${BD.grayText};
  font-family: inherit;
  font-size: 12px;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  &:hover {
    color: ${BD.black};
  }
`

const Item = styled.div`
  padding: 12px 0;
  & + & {
    border-top: 1px solid ${BD.grayBorder};
  }
  dt {
    font-size: 14px;
    font-weight: 600;
    color: ${BD.black};
  }
  dd {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 19px;
    color: ${BD.grayText};
  }
`

export interface AjudaGlossarioProps {
  termos: ChaveTermo[]
  rotulo?: string
}

/**
 * OP-3619 — o glossário como coisa visível.
 *
 * `title` do HTML não existe em toque e é fácil de não achar no mouse. Aqui
 * ele vira um link explícito que abre a folha com os termos daquela tela —
 * mesma folha nas duas larguras, porque a dúvida é a mesma.
 */
export const AjudaGlossario: FC<AjudaGlossarioProps> = ({ termos, rotulo }) => {
  const [aberta, setAberta] = useState(false)
  const lista = termos.map((t) => GLOSSARIO[t]).filter(Boolean)
  if (lista.length === 0) return null

  return (
    <>
      <Gatilho type="button" onClick={() => setAberta(true)}>
        {rotulo ?? 'O que significam estes números?'}
      </Gatilho>
      {aberta && (
        <>
          <FolhaOverlay $open onClick={() => setAberta(false)} />
          <Folha $open role="dialog" aria-label="Glossário">
            <FolhaPega />
            <FolhaTopo>
              <h2>O que cada número quer dizer</h2>
              <Button $variant="secondary" onClick={() => setAberta(false)}>Fechar</Button>
            </FolhaTopo>
            <dl style={{ margin: 0 }}>
              {lista.map((t) => (
                <Item key={t.rotulo}>
                  <dt>{t.rotulo}</dt>
                  <dd>{t.texto}</dd>
                </Item>
              ))}
            </dl>
          </Folha>
        </>
      )}
    </>
  )
}

export default AjudaGlossario
